import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const CREATE_DRAW_MAP_TASK_COMMENT = gql`
  mutation CreateMapDrawTaskComment($input: CreateMapDrawTaskCommentInput!) {
    createMapDrawTaskComment(input: $input) {
      indoorMapDrawTask {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
